import React from "react";

const ShopUrl = "https://boutique.lamallepostale.com"

export const Advertisement = ({product}) => <div className="bg-white mb-20 mt-24">
    <div className="flex flex-col border-b border-gray-200 lg:border-0">
        <div className="relative overflow-hidden rounded-lg">
            <div className="absolute inset-0">
                <img
                    src="/assets/img/bg/boutique.jpg"
                    alt=""
                    className="h-full w-full object-cover object-center"
                />
            </div>
            <div className="relative bg-opacity-75 bg-gray-900">
                <div className="grid px-4 sm:px-6 grid-cols-3 lg:px-8 py-5">
                    <div className="col-span-2">
                        <div className="pr-7">
                            <h1 className="text-xl font-bold tracking-tight text-white">
                                Randonnez bien équipé
                            </h1>
                            <p className="mt-3 text-white">
                                Avant votre départ, pensez à visiter notre boutique !
                            </p>
                            <div className="mt-6">
                                <a
                                    target="_blank"
                                    href={ShopUrl}
                                    className="inline-block rounded-md border border-transparent bg-gray-300 py-1 px-5 font-medium text-gray-800 hover:bg-gray-400"
                                >
                                    Boutique
                                </a>
                            </div>
                        </div>
                    </div>
                    {product && product.picture && <div className="">
                        <a target="_blank" href={product.url ? product.url : ShopUrl}><img className="rounded rounded-lg opacity-85 hover:opacity-70 ml-auto h-36" src={product.picture} /></a>
                    </div>}
                </div>
            </div>
        </div>
    </div>
</div>